(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.addEventListener('add-to-cart', function(event) {
    if (!event.target.matches('.casa-paleta-knife-form')) return;
    if (!window.KROWN || !['overlay', 'popup'].includes(KROWN.settings.cart_action)) return;
    const sidebar = document.getElementById('site-cart-sidebar');
    if (sidebar && typeof sidebar.show === 'function') {
      window.lastFocusedElm = event.target.querySelector('[type="submit"]');
      sidebar.show();
    }
    const recommendations = document.getElementById('cart-recommendations');
    if (recommendations && typeof recommendations.generateRecommendations === 'function') {
      recommendations.generateRecommendations();
    }
  }, true);

  } catch(e) { console.error(e); }
})();
})();
